import { CircularProgress, FormControlLabel, Stack, Switch } from "@mui/material";
import { Text } from "@src/lib/ui-react";

import { useIsWorkerHomeHealthEnabled } from "./api/useIsWorkerHomeHealthEnabled";
import { useUpdateHomeHealthWorkerStatus } from "./api/useUpdateHomeHealthWorkerStatus";

interface Props {
  workerId: string;
}

export function HomeHealthWorkerEnabledToggle(props: Props) {
  const { workerId } = props;
  const {
    data: workerStatus,
    isLoading,
    isRefetching,
    isSuccess,
    isError,
  } = useIsWorkerHomeHealthEnabled(workerId);
  const { mutateAsync: updateStatus, isLoading: isLoadingUpdate } = useUpdateHomeHealthWorkerStatus(
    workerId,
    {
      meta: {
        userSuccessMessage: "Home Health feature flag successfully updated for worker!",
        userErrorMessage: "Failed to toggle Home Health for worker.",
      },
    }
  );

  return (
    <FormControlLabel
      sx={{ ml: 0 }}
      control={
        <Switch
          disabled={isLoading || isError || isLoadingUpdate || isRefetching}
          checked={workerStatus?.data.attributes.homeHealthEnabled}
          inputProps={{ "aria-label": "controlled" }}
          onChange={async () => {
            if (isSuccess) {
              await updateStatus(!workerStatus.data.attributes.homeHealthEnabled);
            }
          }}
        />
      }
      label={
        <Stack direction="row" spacing={1}>
          {(isLoading || isLoadingUpdate) && <CircularProgress size={24} />}
          {isSuccess && (
            <Text>
              Home Health {workerStatus?.data.attributes.homeHealthEnabled ? "Enabled" : "Disabled"}
            </Text>
          )}
        </Stack>
      }
    />
  );
}
